import { render, staticRenderFns } from "./ContestError.vue?vue&type=template&id=3b21fba2&scoped=true&"
import script from "./ContestError.vue?vue&type=script&lang=js&"
export * from "./ContestError.vue?vue&type=script&lang=js&"
import style0 from "./ContestError.vue?vue&type=style&index=0&id=3b21fba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b21fba2",
  null
  
)

export default component.exports